import {
  CountryCode,
  DefaultLocale,
  FakeDefaultLocale,
} from '../types/localization';

export const getLocaleMetaData = (locale: string) => {
  // refactor function to support more regions
  const region = locale?.includes(CountryCode.US)
    ? CountryCode.US
    : CountryCode.DE;
  const localePrefix = locale !== FakeDefaultLocale ? `/${locale}` : '';

  return {
    currency: region === CountryCode.US ? '$' : '€',
    locale: locale === FakeDefaultLocale ? DefaultLocale : locale,
    region,
    isUSA: region === CountryCode.US,
    isDE: region === CountryCode.DE,
    localePrefix,
  };
};
